import { styled } from 'styled-components'

import Clickable from 'core/components/lib/Clickable'
import { onSurfaceMuted } from 'core/styles'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  width: 100%;
`

export const Title = styled.h1`
  margin: 0;
  padding-right: 16px;
  font-size: 22px;
`

export const TitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-right: 16px;
`

export const Subtitle = styled.div`
  margin-top: 8px;
  color: ${onSurfaceMuted};
  font-size: 14px;
  font-weight: 400;
`

export const PaddedWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  padding-left: 16px;
`

export const ActionBar = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 40px;
`

export const ActionBarLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

// LeftPanel removed as it was unused

export const StyledBackLink = styled(Clickable)`
  display: inline-flex;
  align-items: center;
  margin-bottom: 16px;
  font-weight: 500;

  &:hover {
    text-decoration: none;
  }
`

export const Contents = styled.div`
  box-sizing: border-box;
  width: calc(100% - 2px);
  height: 100%;
`
